import {
  DUPLICATED_SALES_REQUEST, DUPLICATED_SALES_SUCCESS, DUPLICATED_SALES_FAILURE
} from '../actions/duplicatedsales'

const INITIAL_STATE = {
  duplicatedSales: null, error: null, loading: false
}

const duplicatedSalesReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case DUPLICATED_SALES_REQUEST:
      return {
        ...state,
        error: null, loading: true
      }
    case DUPLICATED_SALES_SUCCESS:
      return {
        ...state,
        duplicatedSales: action.response, error: null, loading: false
      }
    case DUPLICATED_SALES_FAILURE:
      return {
        ...state,
        error: action.error, loading: false
      }
    default:
      return state
  }
}

export default duplicatedSalesReducer
